import MentorSettingsPageMainComponent, {
  EMR_SETTINGS_SECTIONS,
} from 'src/mentor/components/MentorSettingsPage/MentorSettingsPageMainComponent'
import MentorHeader from '../MentorHeader'
import { useContext } from 'react'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'

export default function MentorSettingsPage() {
  const { mentorClinicAssociationData, mentorProfileData } = useContext(MentorProfileContext)
  return (
    <div style={{ height: '100%', flexDirection: 'column', display: 'flex' }}>
      <MentorHeader greetingsEnabled={true} />
      <MentorSettingsPageMainComponent
        mentorClinicAssociationData={mentorClinicAssociationData}
        defaultSelectedSection={EMR_SETTINGS_SECTIONS.updateLocalData.id}
        excludeSections={[EMR_SETTINGS_SECTIONS.supportOnlyDoctorSettings.id]}
        mentorProfileData={mentorProfileData}
      />
    </div>
  )
}
